export default __webpack_public_path__ + "static/media/martin_romero.a34eecfd.png";